import React from "react";
import {AlertIconRound, AlertIcon} from "@communicare/medications/Components/Icons";
import {EmedStyle} from "../../common/style/emed.style";
import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

export interface IChartExpiryDisplayProps {
    isReviewSoonRequired: boolean,
    numberOfDaysToExpiry: number | undefined,
    isReviewDue: boolean
}


const useStyles = makeStyles({
    root:{
        fontSize:"14px",
        fontWeight:"bold"
    },
    item:{
        display:"flex",
        flexDirection:"column",
        justifyContent:"center"
    },
    expired:{
        color:EmedStyle.EmedBadge.critical
    },
    reviewSoon:{
        color:"#925D07"
    }
})

export const ChartExpiryDisplay = (props: IChartExpiryDisplayProps) => {
    
    let classes = useStyles();
    
        if (props.isReviewSoonRequired) {

            return (
                <Grid container spacing={0} className={classes.root}>
                    <Grid item xs={2} className={classes.item}>
                        <AlertIcon color={EmedStyle.EmedBadge.caution}/>
                    </Grid>
                    <Grid item xs className={`${classes.item} ${classes.reviewSoon}`}>
                        {props.numberOfDaysToExpiry} {props.numberOfDaysToExpiry && props.numberOfDaysToExpiry>1?'days':'day'} left
                    </Grid>
                </Grid>
            );
        }
        

        if (props.isReviewDue) {
            return (
                <Grid container spacing={0} className={classes.root}>
                    <Grid item xs={2} className={classes.item}>
                        <AlertIconRound color={EmedStyle.EmedBadge.critical}/></Grid>
                    <Grid item xs className={`${classes.item} ${classes.expired}`}>
                        Expired
                    </Grid>
                </Grid>
            )
        }
        return null;
    
};
